import { createSelector } from 'reselect';

const selectUpdateBasicInfoState = state => state.UpdateBasicInfo;

export const selectUpdating = createSelector(
  selectUpdateBasicInfoState,
  (state, props) => state.updating
);

export const selectError = createSelector(
  selectUpdateBasicInfoState,
  (state, props) => state.error
);



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateBasicInfo/selectors.js